var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5671 8.19219L11.3171 14.4422C11.2297 14.5297 11.1183 14.5893 10.997 14.6135C10.8757 14.6376 10.75 14.6252 10.6357 14.5779C10.5214 14.5305 10.4238 14.4504 10.3551 14.3475C10.2865 14.2446 10.2499 14.1237 10.25 14V10.893C5.78901 11.1461 2.73042 14.0391 1.87183 14.9555C1.73701 15.0995 1.56021 15.1972 1.36659 15.2349C1.17298 15.2726 0.972411 15.2483 0.793434 15.1653C0.614458 15.0824 0.466192 14.9452 0.369737 14.7731C0.273282 14.6011 0.233552 14.403 0.256203 14.207C0.546046 11.6867 1.92651 9.2625 4.1437 7.38125C5.98511 5.81875 8.22339 4.82735 10.25 4.65391V1.5C10.2499 1.37632 10.2865 1.25539 10.3551 1.15252C10.4238 1.04964 10.5214 0.96946 10.6357 0.922115C10.75 0.87477 10.8757 0.862392 10.997 0.886548C11.1183 0.910705 11.2297 0.970309 11.3171 1.05782L17.5671 7.30782C17.6252 7.36586 17.6713 7.43479 17.7028 7.51067C17.7343 7.58654 17.7504 7.66787 17.7504 7.75C17.7504 7.83214 17.7343 7.91347 17.7028 7.98934C17.6713 8.06521 17.6252 8.13415 17.5671 8.19219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.20b3b61cc06808820fb7350f4d2655cf.svg";
export { ForwardRef as ReactComponent };